export function statusTextForTransfer(transfer: sage.model.ITransfer): string {
    switch (transfer.state) {
        case "APPROVED":
            return "Approved";
        case "COMPLETED":
            return "Completed";
        case "DECLINED":
            return "Declined";
        case "PENDING":
            return "Pending";
    }
}

export function colorClassForTransfer(transfer: sage.model.ITransfer): string {
    switch (transfer.state) {
        case "APPROVED":
            return "primary";
        case "COMPLETED":
            return "success";
        case "DECLINED":
            return "danger";
        case "PENDING":
            return "secondary";
    }
}
